import { createSelector } from '@ngrx/store'
import { RootState } from '../root.model'
import { FilterRedux } from './filters.reducer'

const filterState = (state: RootState) => state.filters

export const selectTransactionSecurityIdFilter = createSelector(
  filterState,
  (state: FilterRedux) => state.transactions.securityId,
)

export const selectTransactionCurrencyCodeFilter = createSelector(
  filterState,
  (state: FilterRedux) => state.transactions.currencyCode,
)

export const selectExtTranIdsFilter = createSelector(
  filterState,
  (state: FilterRedux) => ({
    extTranIds: state.transactions.extTranIds,
    source: state.transactions.extTranIdSource,
  }),
)
